import { render, staticRenderFns } from "./PersonalInfoCardComponent.vue?vue&type=template&id=146b13ba"
import script from "./PersonalInfoCardComponent.vue?vue&type=script&lang=js"
export * from "./PersonalInfoCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports